"use client";
import * as React from "react";
import Link from "next/link";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

import { cn, useAssets, useHref } from "@/lib/utils";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/components/ui/navigation-menu";
import { usePathname } from "@/navigation";

import { Button } from "@/components/ui/button";
import Image from "next/image";
import {
  AccordionLocaleSwitcher,
  MenubarLocaleSwitcher,
} from "../app-locale-switcher";
import { useTranslations } from "next-intl";

export default function AppNavbarDesktop() {
  const href = useHref();
  const asset = useAssets();
  const [overlay, setOverlay] = React.useState(false);
  const closeOverlay = () => setOverlay(false);
  const pathname = usePathname();

  React.useEffect(() => {
    closeOverlay();
  }, [pathname]);

  const t = useTranslations("Menu");
  return (
    <>
      <main className="fixed top-0 w-full bg-white h-[80px] z-50">
        <nav className="flex gap-5 justify-between bx-container text-[#475467]">
          {/* BX LOGO -------- */}
          <Link href="/" className="mr-auto z-50">
            <Image
              src={"/assets/bx-logo.png"}
              width={150}
              height={41.9}
              alt="BroilerX logo"
            />
          </Link>
          {/* ------ */}
          {/* ------ */}

          {/* ------- */}
          {/* HAMBURGER MOBILE */}
          {/* ------- */}
          <input
            checked={overlay}
            onChange={(e) => setOverlay(e.target.checked)}
            aria-hidden="true"
            type="checkbox"
            name="toggle_nav"
            id="toggle_nav"
            className="hidden peer"
          />
          <div className="z-50 relative flex items-center lg:hidden max-h-10">
            <label
              role="button"
              htmlFor="toggle_nav"
              aria-label="humburger"
              id="hamburger"
              className="relative p-6 -mr-6 drop-shadow-md"
            >
              <div
                aria-hidden="true"
                id="line"
                className="m-auto h-0.5 w-5 rounded bg-slate-900 transition duration-300"
              ></div>
              <div
                aria-hidden="true"
                id="line2"
                className="m-auto h-0.5 w-5 rounded bg-slate-900 transition duration-300 mt-1"
              ></div>
              <div
                aria-hidden="true"
                id="line3"
                className="h-0.5 w-3.5 rounded bg-slate-900 transition duration-300 mt-1"
              ></div>
            </label>
          </div>
          {/* TRANSITION BG */}
          <div
            onClick={() => closeOverlay()}
            aria-hidden="true"
            className="fixed z-10 inset-0 h-screen w-screen bg-white/70 backdrop-blur-2xl origin-bottom scale-y-0 transition duration-500 peer-checked:origin-top peer-checked:scale-y-100 lg:hidden"
          ></div>
          {/* MENU NAV ITEMS */}
          <div
            onClick={(e) => e?.stopPropagation?.()}
            className={cn(
              "bg-white lg:min-h-0 lg:overflow-hidden min-h-[30vh] max-h-[90vh] overflow-y-scroll flex-col z-20 flex-wrap gap-6 p-8 justify-between w-full invisible opacity-0 translate-y-1 absolute top-full left-0 transition-all duration-300 scale-95 origin-top lg:relative lg:scale-100 lg:peer-checked:translate-y-0 lg:translate-y-0 lg:flex lg:flex-row lg:items-center lg:gap-0 lg:p-0 lg:bg-transparent lg:w-8/12 lg:visible lg:opacity-100 lg:border-none peer-checked:scale-100 peer-checked:opacity-100 peer-checked:visible lg:shadow-none"
            )}
          >
            <Accordion
              type="multiple"
              className="w-full lg:hidden md:px-24 md:py-4"
            >
              <AccordionItem value="Produk">
                <AccordionTrigger>{t("Product.title")}</AccordionTrigger>
                <AccordionContent className="flex flex-col  gap-3 p-6">
                  <PendaanaanNavItem />
                  <TeknologNavItem />
                  <OtherNavItem />
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="Perusahaan">
                <AccordionTrigger>{t("Company.title")}</AccordionTrigger>
                <AccordionContent>
                  <PerusahaanNavItem />
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="Resource">
                <AccordionTrigger>{t("Resource.title")}</AccordionTrigger>
                <AccordionContent>
                  <ResourceNavItem />
                </AccordionContent>
              </AccordionItem>
              <AccordionLocaleSwitcher />
            </Accordion>
            <Button
              variant="outline"
              className="border-[#F5BE01] font-bold text-[#0C111D] w-full lg:hidden md:px-24 md:py-4"
            >
              <Link href="/hubungi-kami">{t("Util.btnContact")}</Link>
            </Button>
          </div>

          {/* ------- */}
          {/* ------- */}

          {/* ---------- */}
          {/* NAV DESKTOP */}
          {/* ---------- */}
          <div className="hidden lg:ml-auto lg:flex lg:gap-5">
            <NavigationMenu className="">
              <NavigationMenuList>
                <NavigationMenuItem>
                  <NavigationMenuTrigger className="text-inherit">
                    {t("Product.title")}
                  </NavigationMenuTrigger>
                  <NavigationMenuContent className="grid w-[400px] gap-3 p-6 md:w-[400px] md:grid-cols-3 lg:w-[850px]">
                    <PendaanaanNavItem />
                    <TeknologNavItem />
                    <OtherNavItem />
                  </NavigationMenuContent>
                </NavigationMenuItem>
                <NavigationMenuItem>
                  <NavigationMenuTrigger className="text-inherit">
                    {t("Company.title")}
                  </NavigationMenuTrigger>
                  <NavigationMenuContent>
                    <div className="flex flex-col w-[250px] gap-3 p-6">
                      {/* COL 1 */}
                      <PerusahaanNavItem />
                    </div>
                  </NavigationMenuContent>
                </NavigationMenuItem>

                <NavigationMenuItem>
                  <NavigationMenuTrigger className="text-inherit">
                    {t("Resource.title")}
                  </NavigationMenuTrigger>
                  <NavigationMenuContent>
                    <div className="flex flex-col w-[350px] gap-3 p-6">
                      {/* COL 1 */}
                      <ResourceNavItem />
                    </div>
                  </NavigationMenuContent>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>

            <MenubarLocaleSwitcher />

            <Button
              variant="outline"
              className="border-[#F5BE01] font-bold text-[#0C111D]"
            >
              <Link href="/hubungi-kami">{t("Util.btnContact")}</Link>
            </Button>
          </div>
          {/* ---------- */}
        </nav>
      </main>

      {/*  */}
      {/*  */}
      <div className="h-[80px] w-full"></div>
    </>
  );
}

const ListItem = React.forwardRef<
  React.ElementRef<"a">,
  React.ComponentPropsWithoutRef<"a">
>(({ className, title, children, ...props }, ref) => {
  return (
    <li>
      <NavigationMenuLink asChild>
        <a
          ref={ref}
          className={cn(
            "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
            className
          )}
          {...props}
        >
          <div className="text-sm font-medium leading-none">{title}</div>
          <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
            {children}
          </p>
        </a>
      </NavigationMenuLink>
    </li>
  );
});
ListItem.displayName = "ListItem";

function PendaanaanNavItem() {
  const t = useTranslations("Menu");
  const pathname = usePathname();
  return (
    <div>
      <p className="text-[#D0D5DD] font-bold block mb-2 ml-6 capitalize">
        {t("Product.Pendanaan.title")}
      </p>
      <ul className="text-xs text-[#667085]">
        <li>
          <Link
            href={"/pendanaan-budidaya-kemitraan"}
            className={cn(
              pathname == "/pendanaan-budidaya-kemitraan" &&
                "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.0801 19.9451C13.4684 20.0284 13.0601 20.3014 13.0301 20.3216C12.6299 20.5987 13.0458 21.2119 13.4519 20.9415C13.4898 20.9171 14.3786 20.3407 15.4214 20.9542C15.5969 21.0581 15.8291 21.0007 15.9348 20.8211C16.2221 20.2252 15.1672 20.0336 14.8316 19.9549L14.8949 19.1929C14.7277 19.221 14.4652 19.257 14.1356 19.2795L14.0801 19.9451Z"
                  fill="currentColor"
                />
                <path
                  d="M3.9028 7.20188C3.9613 7.34101 4.0978 7.43138 4.24855 7.43138H4.93105C4.98618 7.85476 5.17143 8.60626 5.77705 8.96476C5.0983 12.687 7.33143 16.2041 7.45255 16.3909C8.49505 17.8189 9.80755 18.567 11.0503 18.9458L10.7128 19.9088C9.97593 19.9515 9.40255 20.2864 9.3643 20.3093C8.94543 20.571 9.32493 21.1988 9.75018 20.9524C9.76143 20.9456 10.8669 20.2969 11.7703 20.9366C11.9394 21.057 12.1734 21.0169 12.2931 20.8478C12.6006 20.3509 11.8127 20.085 11.4812 19.9838L11.7801 19.131C12.6534 19.3016 13.3603 19.3286 14.1358 19.2795L14.2667 17.7045C14.2839 17.4983 14.4602 17.3408 14.6713 17.3621C14.8776 17.379 15.0309 17.5601 15.0137 17.7668L14.8952 19.1929C19.2958 18.852 19.5861 13.473 19.5129 12.5711C20.1891 11.4814 20.6987 9.68851 18.7161 9.66638H12.8312C11.2851 9.63451 11.1939 8.83426 11.1287 8.63626C11.0957 8.55188 10.4278 6.87601 9.2428 5.72963C9.42355 4.89301 9.35718 4.21013 9.0403 3.70313C8.3683 2.74238 7.55643 2.87288 7.01568 3.35026C6.3523 3.14363 5.6248 3.27226 5.39905 3.97088C4.37905 4.05526 4.32205 5.48588 4.93143 5.82076L3.98118 6.79388C3.87505 6.90226 3.8443 7.06313 3.9028 7.20188ZM10.4162 10.6556C10.5332 10.1779 11.2476 10.3373 11.1478 10.8203C11.1426 10.8446 10.9607 11.7326 11.4294 12.315C11.7268 12.684 12.2421 12.8711 12.9621 12.8711C13.1694 12.8711 13.3371 13.0388 13.3371 13.2461C13.3371 13.4535 13.1694 13.6211 12.9621 13.6211C10.7417 13.6714 10.1357 11.943 10.4162 10.6556ZM9.1933 10.6504C9.31593 10.1753 10.0288 10.3444 9.9223 10.8266C9.91743 10.8461 9.4693 12.7849 10.4327 14.3246C10.9903 15.216 11.9207 15.8138 13.1979 16.1006C13.4162 16.1209 15.1746 16.2229 16.0599 14.934C15.5784 14.9936 14.9859 14.9355 14.5183 14.4679C14.4268 14.3764 14.3889 14.244 14.4182 14.1176C14.4474 13.9916 14.5397 13.8896 14.6623 13.8476C14.6721 13.8439 15.8008 13.4389 16.1263 12.3619C16.1863 12.1635 16.3944 12.051 16.5936 12.1114C16.7919 12.171 16.9041 12.3806 16.8441 12.5786C16.6026 13.3774 16.0584 13.8896 15.6073 14.1926C16.0888 14.2474 16.5827 14.0179 16.5894 14.0145C16.7241 13.9485 16.8853 13.9691 16.9993 14.0681C17.1133 14.1668 17.1568 14.3231 17.1111 14.4664C16.4964 16.3804 14.6466 16.8641 13.4837 16.8645C9.55593 16.494 8.65368 12.8903 9.1933 10.6504ZM6.85068 5.46226C7.56505 5.47501 7.56543 6.53701 6.85068 6.54938C6.1363 6.53663 6.13705 5.47463 6.85068 5.46226Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            {t("Product.Pendanaan.items.PendanaanBudidayaKemitraanAyam")}
          </Link>
        </li>

        <li>
          <Link
            href={"/pendanaan-perbaikan-kandang"}
            className={cn(
              pathname == "/pendanaan-perbaikan-kandang" &&
                "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.5 22.7399L12 19.1399L7.5 22.7399V22.9999H16.5V22.7399Z"
                  fill="currentColor"
                />
                <path
                  d="M16.4998 15.5398L12.7998 18.4998L16.4998 21.4598V15.5398Z"
                  fill="currentColor"
                />
                <path
                  d="M20.9645 11.814L18.9645 6.814C18.921 6.7055 18.8405 6.615 18.737 6.5595L12.237 3.0595C12.163 3.02 12.0815 3 12 3C11.9185 3 11.837 3.02 11.763 3.0595L5.263 6.5595C5.1595 6.615 5.0795 6.7055 5.0355 6.814L3.0355 11.814C3.012 11.8735 3 11.9365 3 12V22.5C3 22.776 3.224 23 3.5 23H6.5V14.5C6.517 14.2235 6.7225 14.0165 7 14H17C17.2715 14.014 17.4885 14.2275 17.5 14.5V23H20.5C20.776 23 21 22.776 21 22.5C21.0015 20.657 20.999 13.7025 21 12C21 11.9365 20.988 11.8735 20.9645 11.814ZM15 10C15 10.276 14.776 10.5 14.5 10.5H9.5C9.224 10.5 9 10.276 9 10V8C9 7.8245 9.092 7.6615 9.2425 7.5715L11.7425 6.0715C11.901 5.9765 12.0985 5.9765 12.257 6.0715L14.757 7.5715C14.908 7.6615 15 7.8245 15 8V10Z"
                  fill="currentColor"
                />
                <path
                  d="M10 8.28301V9.50001H14V8.28301L12 7.08301L10 8.28301Z"
                  fill="currentColor"
                />
                <path
                  d="M15.5748 15H8.4248L11.9998 17.86L15.5748 15Z"
                  fill="currentColor"
                />
                <path
                  d="M7.5 21.4598L11.2 18.4998L7.5 15.5398V21.4598Z"
                  fill="currentColor"
                />
                <path
                  d="M1.5 14.4999H2V11.9999C1.759 12.0174 4.086 6.61389 4.108 6.44089C4.239 6.11489 4.4815 5.84439 4.789 5.67939L11.2895 2.17939C11.725 1.94189 12.276 1.94139 12.7115 2.17939L19.2105 5.67889C19.5195 5.84439 19.7615 6.11539 19.8935 6.44289L21.8945 11.4454C22.1085 11.8174 21.9565 14.0669 22 14.4999H22.5C22.776 14.4999 23 14.2759 23 13.9999C22.9985 13.9319 23.0255 11.8149 22.967 11.8204L20.467 5.32039C20.422 5.20389 20.3355 5.10839 20.224 5.05239L12.224 1.05239C12.0835 0.981887 11.9175 0.981887 11.7765 1.05239L3.7765 5.05239C3.665 5.10839 3.5785 5.20389 3.5335 5.32039L1.0335 11.8204C1.011 11.8774 1 11.9384 1 11.9999V13.9999C1 14.2759 1.224 14.4999 1.5 14.4999Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            {t("Product.Pendanaan.items.PendanaanUpgradeKandang")}
          </Link>
        </li>
      </ul>
    </div>
  );
}

function TeknologNavItem() {
  const t = useTranslations("Menu");
  const pathname = usePathname();
  return (
    <div>
      <p className="text-[#D0D5DD] font-bold block mb-2 ml-6 capitalize">
        {t("Product.Teknologi.title")}
      </p>
      <ul className="text-xs  text-[#667085]">
        <li>
          <Link
            href="/teknologi/app"
            className={cn(
              pathname == "/teknologi/app" && "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 21.375C12.2071 21.375 12.375 21.2071 12.375 21C12.375 20.7929 12.2071 20.625 12 20.625C11.7929 20.625 11.625 20.7929 11.625 21C11.625 21.2071 11.7929 21.375 12 21.375Z"
                  fill="currentColor"
                />
                <path
                  d="M15.75 1.125H8.25C7.65345 1.1256 7.0815 1.36284 6.65967 1.78467C6.23784 2.2065 6.0006 2.77845 6 3.375H18C17.9994 2.77845 17.7622 2.2065 17.3403 1.78467C16.9185 1.36284 16.3466 1.1256 15.75 1.125ZM13.125 2.625H10.875C10.7755 2.625 10.6802 2.58549 10.6098 2.51516C10.5395 2.44484 10.5 2.34946 10.5 2.25C10.5 2.15054 10.5395 2.05516 10.6098 1.98484C10.6802 1.91451 10.7755 1.875 10.875 1.875H13.125C13.2245 1.875 13.3198 1.91451 13.3902 1.98484C13.4605 2.05516 13.5 2.15054 13.5 2.25C13.5 2.34946 13.4605 2.44484 13.3902 2.51516C13.3198 2.58549 13.2245 2.625 13.125 2.625Z"
                  fill="currentColor"
                />
                <path d="M6 4.125H18V18.375H6V4.125Z" fill="currentColor" />
                <path
                  d="M6 20.625C6.0006 21.2216 6.23784 21.7935 6.65967 22.2153C7.0815 22.6372 7.65345 22.8744 8.25 22.875H15.75C16.3466 22.8744 16.9185 22.6372 17.3403 22.2153C17.7622 21.7935 17.9994 21.2216 18 20.625V19.125H6V20.625ZM12 19.875C12.2225 19.875 12.44 19.941 12.625 20.0646C12.81 20.1882 12.9542 20.3639 13.0394 20.5695C13.1245 20.775 13.1468 21.0012 13.1034 21.2195C13.06 21.4377 12.9528 21.6382 12.7955 21.7955C12.6382 21.9528 12.4377 22.06 12.2195 22.1034C12.0012 22.1468 11.775 22.1245 11.5695 22.0394C11.3639 21.9542 11.1882 21.81 11.0646 21.625C10.941 21.44 10.875 21.2225 10.875 21C10.875 20.7016 10.9935 20.4155 11.2045 20.2045C11.4155 19.9935 11.7016 19.875 12 19.875Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            {t("Product.Teknologi.items.App")}
          </Link>
        </li>

        <li>
          <Link
            href="/teknologi/iot"
            className={cn(
              pathname == "/teknologi/iot" && "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M21.9969 9.649C21.9969 8.783 21.5969 7.966 20.9139 7.435C19.3079 6.185 15.6579 3.347 13.7219 1.841C12.7089 1.053 11.2909 1.053 10.2779 1.841C8.34193 3.347 4.69193 6.185 3.08593 7.435C2.40293 7.966 2.00293 8.783 2.00293 9.649V19.945C2.00293 20.689 2.29893 21.402 2.82493 21.928C3.35093 22.454 4.06393 22.75 4.80793 22.75H19.1919C19.9359 22.75 20.6489 22.454 21.1749 21.928C21.7009 21.402 21.9969 20.689 21.9969 19.945V9.649ZM11.9999 18.174C11.4479 18.174 10.9999 17.726 10.9999 17.174C10.9999 16.622 11.4479 16.174 11.9999 16.174C12.5519 16.174 12.9999 16.622 12.9999 17.174C12.9999 17.726 12.5519 18.174 11.9999 18.174ZM10.0299 14.932C10.5319 14.43 11.2289 14.114 11.9999 14.114C12.7709 14.114 13.4679 14.43 13.9699 14.932C14.2619 15.225 14.7379 15.225 15.0299 14.932C15.3229 14.639 15.3229 14.164 15.0299 13.871C14.2589 13.099 13.1859 12.614 11.9999 12.614C10.8139 12.614 9.74193 13.099 8.96993 13.871C8.67693 14.164 8.67693 14.639 8.96993 14.932C9.26193 15.225 9.73793 15.225 10.0299 14.932ZM7.53293 12.429C8.67093 11.281 10.2509 10.576 11.9999 10.576C13.7489 10.576 15.3289 11.281 16.4669 12.429C16.7589 12.723 17.2339 12.726 17.5279 12.434C17.8219 12.143 17.8239 11.668 17.5329 11.374C16.1229 9.951 14.1659 9.076 11.9999 9.076C9.83393 9.076 7.87693 9.951 6.46693 11.374C6.17593 11.668 6.17793 12.143 6.47193 12.434C6.76593 12.726 7.24093 12.723 7.53293 12.429Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            {t("Product.Teknologi.items.IOT")}
          </Link>
        </li>

        <li>
          <Link
            href="/teknologi/erp"
            className={cn(
              pathname == "/teknologi/erp" && "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 21.375C12.2071 21.375 12.375 21.2071 12.375 21C12.375 20.7929 12.2071 20.625 12 20.625C11.7929 20.625 11.625 20.7929 11.625 21C11.625 21.2071 11.7929 21.375 12 21.375Z"
                  fill="currentColor"
                />
                <path
                  d="M15.75 1.125H8.25C7.65345 1.1256 7.0815 1.36284 6.65967 1.78467C6.23784 2.2065 6.0006 2.77845 6 3.375H18C17.9994 2.77845 17.7622 2.2065 17.3403 1.78467C16.9185 1.36284 16.3466 1.1256 15.75 1.125ZM13.125 2.625H10.875C10.7755 2.625 10.6802 2.58549 10.6098 2.51516C10.5395 2.44484 10.5 2.34946 10.5 2.25C10.5 2.15054 10.5395 2.05516 10.6098 1.98484C10.6802 1.91451 10.7755 1.875 10.875 1.875H13.125C13.2245 1.875 13.3198 1.91451 13.3902 1.98484C13.4605 2.05516 13.5 2.15054 13.5 2.25C13.5 2.34946 13.4605 2.44484 13.3902 2.51516C13.3198 2.58549 13.2245 2.625 13.125 2.625Z"
                  fill="currentColor"
                />
                <path d="M6 4.125H18V18.375H6V4.125Z" fill="currentColor" />
                <path
                  d="M6 20.625C6.0006 21.2216 6.23784 21.7935 6.65967 22.2153C7.0815 22.6372 7.65345 22.8744 8.25 22.875H15.75C16.3466 22.8744 16.9185 22.6372 17.3403 22.2153C17.7622 21.7935 17.9994 21.2216 18 20.625V19.125H6V20.625ZM12 19.875C12.2225 19.875 12.44 19.941 12.625 20.0646C12.81 20.1882 12.9542 20.3639 13.0394 20.5695C13.1245 20.775 13.1468 21.0012 13.1034 21.2195C13.06 21.4377 12.9528 21.6382 12.7955 21.7955C12.6382 21.9528 12.4377 22.06 12.2195 22.1034C12.0012 22.1468 11.775 22.1245 11.5695 22.0394C11.3639 21.9542 11.1882 21.81 11.0646 21.625C10.941 21.44 10.875 21.2225 10.875 21C10.875 20.7016 10.9935 20.4155 11.2045 20.2045C11.4155 19.9935 11.7016 19.875 12 19.875Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            {t("Product.Teknologi.items.ERP")}
          </Link>
        </li>
      </ul>
    </div>
  );
}

function OtherNavItem() {
  const t = useTranslations("Menu");
  const pathname = usePathname();
  return (
    <div>
      <p className="text-[#D0D5DD] font-bold block mb-2 ml-6 capitalize">
        {t("Product.Other.title")}
      </p>
      <ul className="text-xs  text-[#667085]">
        <li>
          <Link
            href={"/sapronak"}
            className={cn(
              pathname == "/sapronak" && "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.1237 10.8768C18.822 10.8392 18.5253 10.8991 18.2671 11.0467C17.8018 10.2971 17.2 9.6325 16.48 9.08974C16.5243 9.03805 16.5686 8.98265 16.6129 8.92728C17.3883 8.32913 18.4332 8.04112 19.6332 8.18882C19.7588 9.22266 19.5631 10.1457 19.1237 10.8768Z"
                  fill="currentColor"
                />
                <path
                  d="M7.51883 9.08976C6.88746 9.56606 6.34468 10.1384 5.90529 10.7772C5.53339 10.611 5.12418 10.6297 4.81605 10.7735C4.42099 10.0571 4.24744 9.17468 4.3656 8.18884C5.56191 8.04114 6.60684 8.32915 7.38221 8.92361C7.42652 8.97898 7.47083 9.03437 7.51883 9.08976Z"
                  fill="currentColor"
                />
                <path
                  d="M15.2289 9.20439C16.3292 8.26653 17.0233 6.87084 17.0233 5.30898C17.0233 2.48069 14.7341 0.184082 11.9021 0.184082C9.07009 0.184082 6.77346 2.48069 6.77346 5.30898C6.77346 6.87084 7.47501 8.27022 8.57531 9.20808C7.71502 9.70654 6.97656 10.3933 6.41162 11.2093L8.70455 13.0702L10.6725 11.3939C11.4606 10.7218 12.6345 10.7215 13.4307 11.4419L15.4799 13.3176L17.5882 11.5158C17.0085 10.5632 16.1962 9.7656 15.2289 9.20439ZM9.78271 5.20191C9.26577 5.20191 8.84487 4.78099 8.84487 4.26038C8.84487 3.74345 9.26577 3.32254 9.78271 3.32254C10.3033 3.32254 10.7205 3.74344 10.7205 4.26038C10.7205 4.78099 10.3033 5.20191 9.78271 5.20191ZM13.0504 6.84499L12.2233 8.32931C12.0879 8.58426 11.7167 8.58496 11.5809 8.32931L10.7501 6.84499C10.6504 6.66777 10.7168 6.44252 10.8941 6.34284C11.0713 6.24314 11.2965 6.3096 11.3962 6.48682L11.9021 7.39144L12.4042 6.48682C12.5039 6.3096 12.7292 6.24314 12.9064 6.34284C13.0836 6.44252 13.1501 6.66777 13.0504 6.84499ZM14.0178 5.20191C13.5009 5.20191 13.0799 4.78099 13.0799 4.26038C13.0799 3.74345 13.5009 3.32254 14.0178 3.32254C14.5384 3.32254 14.9556 3.74344 14.9556 4.26038C14.9556 4.78099 14.5384 5.20191 14.0178 5.20191Z"
                  fill="currentColor"
                />
                <path
                  d="M11.9876 23.8162C6.58776 23.8162 2.71313 20.6638 2.31634 14.7496C2.295 14.4315 2.41876 14.1203 2.64259 13.8932L4.92842 11.5746C5.14479 11.3552 5.49246 11.3358 5.73191 11.5299L8.42943 13.7163C8.65341 13.8978 8.97493 13.894 9.19452 13.7072L11.2534 11.956C11.7695 11.517 12.5317 11.5307 13.0316 11.988L15.1738 13.9474C15.3968 14.1514 15.7369 14.1572 15.9668 13.9609L18.561 11.746C18.7738 11.5643 19.084 11.5542 19.3082 11.7216L21.178 13.1181C21.5111 13.3668 21.6973 13.7648 21.6856 14.1803C21.5137 20.3279 17.6833 23.8162 11.9876 23.8162Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            {t("Product.Other.items.Sapronak")}
          </Link>
        </li>

        <li>
          <Link
            href={"/karkas-dan-telur"}
            className={cn(
              pathname == "/karkas-dan-telur" && "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5592 6.72193C9.30077 7.05677 0 9.60929 0 16.7032C0 19.6519 2.41781 21.4839 6.31026 21.4839H20.7931C22.8987 21.4839 24 20.4023 24 19.8223C24 19.7768 23.9706 19.7415 23.9299 19.7259C22.5492 19.2629 21.6267 18.5421 21.1885 17.5839C20.9412 17.0427 20.9023 16.5753 20.8966 16.1892C20.8767 14.8006 20.0326 12.5551 18.3871 9.51464C18.366 9.48658 18.3424 9.45503 18.3161 9.42039C17.4497 10.5977 16.5519 12.1612 16.5519 13.584C16.5519 16.1077 14.5099 18.1606 12.0002 18.1606C9.49045 18.1606 7.44832 16.1077 7.44832 13.5842C7.44832 11.0607 9.49026 9.00735 12 9.00735C13.3848 9.00735 14.9044 8.14258 16.0593 7.29677C16.0082 7.26426 15.953 7.24239 15.911 7.20658C15.2069 6.60561 12.8361 6.69348 12.5592 6.72193Z"
                  fill="currentColor"
                />
                <path
                  d="M16.548 3.57321C16.4226 3.4803 16.2649 3.43869 16.105 3.45689C15.7154 3.49947 15.1961 3.06263 15.0577 2.86579C14.7136 2.37708 14.0015 2.5623 13.8585 3.11953C13.7929 3.37501 13.8788 3.65643 14.083 3.85405C14.2073 3.97385 14.2092 4.18037 14.0873 4.30269C13.8806 4.51056 13.2809 5.1185 12.6142 5.79514L12.4121 6.00011C13.0193 5.94166 13.6222 5.90005 14.2322 5.95076L14.2665 5.91089C14.768 5.32966 15.2623 4.76218 15.4816 4.54908C15.5681 4.46508 15.6916 4.43876 15.8044 4.48076C16.0489 4.57172 16.3096 4.5634 16.519 4.45869C16.9013 4.26708 16.8748 3.81398 16.548 3.57321Z"
                  fill="currentColor"
                />
                <path
                  d="M18.0234 6.75879C17.0715 7.63614 14.433 9.84318 11.9999 9.84318C9.94659 9.84318 8.27588 11.5214 8.27588 13.5843C8.27588 15.6469 9.94659 17.3252 11.9999 17.3252C14.0533 17.3252 15.724 15.6469 15.724 13.5843C15.724 11.138 17.9188 8.4866 18.7925 7.52892C18.7612 7.34756 18.718 7.10679 18.5837 6.96995C18.4497 6.8335 18.201 6.78976 18.0234 6.75879Z"
                  fill="currentColor"
                />
                <path
                  d="M22.513 3.80418C22.2486 3.72443 21.8108 3.28392 21.732 3.01817C21.4986 2.2403 20.3212 2.41024 20.3212 3.22566V4.2654C20.3212 4.48818 20.2349 4.69759 20.0783 4.85495L18.9434 5.99572C19.2182 6.15211 19.393 6.32843 19.5486 6.60579L20.6863 5.4623C20.8426 5.30514 21.0501 5.21863 21.271 5.21863H22.3055C23.1128 5.21843 23.2914 4.03972 22.513 3.80418Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            {t("Product.Other.items.AyamTelur")}
          </Link>
        </li>
      </ul>
    </div>
  );
}

function PerusahaanNavItem() {
  const t = useTranslations("Menu");
  const pathname = usePathname();
  return (
    <div>
      <p className="text-[#D0D5DD] font-bold block mb-2 ml-6 capitalize">
        {t("Company.title")}
      </p>
      <ul className="text-xs font-semibold text-[#667085]">
        <li>
          <Link
            href={"/profil"}
            className={cn(
              pathname == "/profil" && "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 4.125C4 3.56141 4.22388 3.02091 4.6224 2.6224C5.02091 2.22388 5.56141 2 6.125 2H13.875C14.4386 2 14.9791 2.22388 15.3776 2.6224C15.7761 3.02091 16 3.56141 16 4.125V9.5H17.875C18.4386 9.5 18.9791 9.72388 19.3776 10.1224C19.7761 10.5209 20 11.0614 20 11.625V21.375C20 21.72 19.72 22 19.375 22H17V18.625C17 18.3266 16.8815 18.0405 16.6705 17.8295C16.4595 17.6185 16.1734 17.5 15.875 17.5H8.125C7.82663 17.5 7.54048 17.6185 7.3295 17.8295C7.11853 18.0405 7 18.3266 7 18.625V22H4.625C4.28 22 4 21.72 4 21.375V4.125ZM8.25 22H11.375V18.75H8.25V22ZM12.625 22H15.75V18.75H12.625V22ZM9 7C9 6.73478 8.89464 6.48043 8.70711 6.29289C8.51957 6.10536 8.26522 6 8 6C7.73478 6 7.48043 6.10536 7.29289 6.29289C7.10536 6.48043 7 6.73478 7 7C7 7.26522 7.10536 7.51957 7.29289 7.70711C7.48043 7.89464 7.73478 8 8 8C8.26522 8 8.51957 7.89464 8.70711 7.70711C8.89464 7.51957 9 7.26522 9 7ZM8 11.5C8.26522 11.5 8.51957 11.3946 8.70711 11.2071C8.89464 11.0196 9 10.7652 9 10.5C9 10.2348 8.89464 9.98043 8.70711 9.79289C8.51957 9.60536 8.26522 9.5 8 9.5C7.73478 9.5 7.48043 9.60536 7.29289 9.79289C7.10536 9.98043 7 10.2348 7 10.5C7 10.7652 7.10536 11.0196 7.29289 11.2071C7.48043 11.3946 7.73478 11.5 8 11.5ZM9 14C9 13.7348 8.89464 13.4804 8.70711 13.2929C8.51957 13.1054 8.26522 13 8 13C7.73478 13 7.48043 13.1054 7.29289 13.2929C7.10536 13.4804 7 13.7348 7 14C7 14.2652 7.10536 14.5196 7.29289 14.7071C7.48043 14.8946 7.73478 15 8 15C8.26522 15 8.51957 14.8946 8.70711 14.7071C8.89464 14.5196 9 14.2652 9 14ZM12 8C12.2652 8 12.5196 7.89464 12.7071 7.70711C12.8946 7.51957 13 7.26522 13 7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6C11.7348 6 11.4804 6.10536 11.2929 6.29289C11.1054 6.48043 11 6.73478 11 7C11 7.26522 11.1054 7.51957 11.2929 7.70711C11.4804 7.89464 11.7348 8 12 8ZM13 10.5C13 10.2348 12.8946 9.98043 12.7071 9.79289C12.5196 9.60536 12.2652 9.5 12 9.5C11.7348 9.5 11.4804 9.60536 11.2929 9.79289C11.1054 9.98043 11 10.2348 11 10.5C11 10.7652 11.1054 11.0196 11.2929 11.2071C11.4804 11.3946 11.7348 11.5 12 11.5C12.2652 11.5 12.5196 11.3946 12.7071 11.2071C12.8946 11.0196 13 10.7652 13 10.5ZM12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14C13 13.7348 12.8946 13.4804 12.7071 13.2929C12.5196 13.1054 12.2652 13 12 13C11.7348 13 11.4804 13.1054 11.2929 13.2929C11.1054 13.4804 11 13.7348 11 14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15ZM17 14C17 13.7348 16.8946 13.4804 16.7071 13.2929C16.5196 13.1054 16.2652 13 16 13C15.7348 13 15.4804 13.1054 15.2929 13.2929C15.1054 13.4804 15 13.7348 15 14C15 14.2652 15.1054 14.5196 15.2929 14.7071C15.4804 14.8946 15.7348 15 16 15C16.2652 15 16.5196 14.8946 16.7071 14.7071C16.8946 14.5196 17 14.2652 17 14Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            {t("Company.TentangKami")}
          </Link>
        </li>

        <li>
          <Link
            href={"/karir"}
            className={cn(
              pathname == "/karir" && "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5 13.5C20.1992 13.5002 20.8913 13.3601 21.5354 13.0882C22.1795 12.8163 22.7625 12.4179 23.25 11.9167V18.75C23.25 19.5456 22.9339 20.3087 22.3713 20.8713C21.8087 21.4339 21.0456 21.75 20.25 21.75H4.5C3.70435 21.75 2.94129 21.4339 2.37868 20.8713C1.81607 20.3087 1.5 19.5456 1.5 18.75V11.9167C1.9875 12.4179 2.57054 12.8163 3.21464 13.0882C3.85875 13.3601 4.55084 13.5002 5.25 13.5H6V14.25C6 14.4489 6.07902 14.6397 6.21967 14.7803C6.36032 14.921 6.55109 15 6.75 15C6.94891 15 7.13968 14.921 7.28033 14.7803C7.42098 14.6397 7.5 14.4489 7.5 14.25V13.5H17.25V14.25C17.25 14.4489 17.329 14.6397 17.4697 14.7803C17.6103 14.921 17.8011 15 18 15C18.1989 15 18.3897 14.921 18.5303 14.7803C18.671 14.6397 18.75 14.4489 18.75 14.25V13.5H19.5ZM23.25 7.5V8.25C23.2488 9.2442 22.8533 10.1973 22.1503 10.9003C21.4473 11.6033 20.4942 11.9988 19.5 12H18.75V11.25C18.75 11.0511 18.671 10.8603 18.5303 10.7197C18.3897 10.579 18.1989 10.5 18 10.5C17.8011 10.5 17.6103 10.579 17.4697 10.7197C17.329 10.8603 17.25 11.0511 17.25 11.25V12H7.5V11.25C7.5 11.0511 7.42098 10.8603 7.28033 10.7197C7.13968 10.579 6.94891 10.5 6.75 10.5C6.55109 10.5 6.36032 10.579 6.21967 10.7197C6.07902 10.8603 6 11.0511 6 11.25V12H5.25C4.2558 11.9988 3.30267 11.6033 2.59966 10.9003C1.89666 10.1973 1.50119 9.2442 1.5 8.25V7.5C1.5 6.70435 1.81607 5.94129 2.37868 5.37868C2.94129 4.81607 3.70435 4.5 4.5 4.5H8.25V3.75C8.25 3.35218 8.40804 2.97064 8.68934 2.68934C8.97064 2.40804 9.35218 2.25 9.75 2.25H14.25C14.6478 2.25 15.0294 2.40804 15.3107 2.68934C15.592 2.97064 15.75 3.35218 15.75 3.75V4.5H20.25C21.0456 4.5 21.8087 4.81607 22.3713 5.37868C22.9339 5.94129 23.25 6.70435 23.25 7.5ZM14.25 3.75H9.75V4.5H14.25V3.75Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            {t("Company.Career")}
          </Link>
        </li>

        <li>
          <Link
            href={"/temukan-kami"}
            className={cn(
              pathname == "/temukan-kami" && "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5 13.5C20.1992 13.5002 20.8913 13.3601 21.5354 13.0882C22.1795 12.8163 22.7625 12.4179 23.25 11.9167V18.75C23.25 19.5456 22.9339 20.3087 22.3713 20.8713C21.8087 21.4339 21.0456 21.75 20.25 21.75H4.5C3.70435 21.75 2.94129 21.4339 2.37868 20.8713C1.81607 20.3087 1.5 19.5456 1.5 18.75V11.9167C1.9875 12.4179 2.57054 12.8163 3.21464 13.0882C3.85875 13.3601 4.55084 13.5002 5.25 13.5H6V14.25C6 14.4489 6.07902 14.6397 6.21967 14.7803C6.36032 14.921 6.55109 15 6.75 15C6.94891 15 7.13968 14.921 7.28033 14.7803C7.42098 14.6397 7.5 14.4489 7.5 14.25V13.5H17.25V14.25C17.25 14.4489 17.329 14.6397 17.4697 14.7803C17.6103 14.921 17.8011 15 18 15C18.1989 15 18.3897 14.921 18.5303 14.7803C18.671 14.6397 18.75 14.4489 18.75 14.25V13.5H19.5ZM23.25 7.5V8.25C23.2488 9.2442 22.8533 10.1973 22.1503 10.9003C21.4473 11.6033 20.4942 11.9988 19.5 12H18.75V11.25C18.75 11.0511 18.671 10.8603 18.5303 10.7197C18.3897 10.579 18.1989 10.5 18 10.5C17.8011 10.5 17.6103 10.579 17.4697 10.7197C17.329 10.8603 17.25 11.0511 17.25 11.25V12H7.5V11.25C7.5 11.0511 7.42098 10.8603 7.28033 10.7197C7.13968 10.579 6.94891 10.5 6.75 10.5C6.55109 10.5 6.36032 10.579 6.21967 10.7197C6.07902 10.8603 6 11.0511 6 11.25V12H5.25C4.2558 11.9988 3.30267 11.6033 2.59966 10.9003C1.89666 10.1973 1.50119 9.2442 1.5 8.25V7.5C1.5 6.70435 1.81607 5.94129 2.37868 5.37868C2.94129 4.81607 3.70435 4.5 4.5 4.5H8.25V3.75C8.25 3.35218 8.40804 2.97064 8.68934 2.68934C8.97064 2.40804 9.35218 2.25 9.75 2.25H14.25C14.6478 2.25 15.0294 2.40804 15.3107 2.68934C15.592 2.97064 15.75 3.35218 15.75 3.75V4.5H20.25C21.0456 4.5 21.8087 4.81607 22.3713 5.37868C22.9339 5.94129 23.25 6.70435 23.25 7.5ZM14.25 3.75H9.75V4.5H14.25V3.75Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            {t("Company.BroilerXUnit")}
          </Link>
        </li>
      </ul>
    </div>
  );
}

function ResourceNavItem() {
  const t = useTranslations("Menu");
  const pathname = usePathname();
  return (
    <div>
      <p className="text-[#D0D5DD] font-bold block mb-2 ml-6 capitalize">
        {t("Resource.title")}
      </p>
      <ul className="text-xs font-semibold text-[#667085]">
        <li>
          <Link
            href={"/faq"}
            className={cn(
              pathname == "/faq" && "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96451 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM12 18C11.7775 18 11.56 17.934 11.375 17.8104C11.19 17.6868 11.0458 17.5111 10.9606 17.3055C10.8755 17.1 10.8532 16.8738 10.8966 16.6555C10.94 16.4373 11.0472 16.2368 11.2045 16.0795C11.3618 15.9222 11.5623 15.815 11.7805 15.7716C11.9988 15.7282 12.225 15.7505 12.4305 15.8356C12.6361 15.9208 12.8118 16.065 12.9354 16.25C13.059 16.435 13.125 16.6525 13.125 16.875C13.125 17.1734 13.0065 17.4595 12.7955 17.6705C12.5845 17.8815 12.2984 18 12 18ZM12.75 13.4325V13.5C12.75 13.6989 12.671 13.8897 12.5303 14.0303C12.3897 14.171 12.1989 14.25 12 14.25C11.8011 14.25 11.6103 14.171 11.4697 14.0303C11.329 13.8897 11.25 13.6989 11.25 13.5V12.75C11.25 12.5511 11.329 12.3603 11.4697 12.2197C11.6103 12.079 11.8011 12 12 12C13.2403 12 14.25 11.1562 14.25 10.125C14.25 9.09375 13.2403 8.25 12 8.25C10.7597 8.25 9.75 9.09375 9.75 10.125V10.5C9.75 10.6989 9.67099 10.8897 9.53033 11.0303C9.38968 11.171 9.19892 11.25 9 11.25C8.80109 11.25 8.61033 11.171 8.46967 11.0303C8.32902 10.8897 8.25 10.6989 8.25 10.5V10.125C8.25 8.26406 9.93188 6.75 12 6.75C14.0681 6.75 15.75 8.26406 15.75 10.125C15.75 11.7544 14.46 13.1184 12.75 13.4325Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            {t("Resource.FAQ")}
          </Link>
        </li>

        <li>
          <Link
            href={"https://blog.broilerx.com/"}
            className="inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5 1.5H4.5C3.90326 1.5 3.33097 1.73705 2.90901 2.15901C2.48705 2.58097 2.25 3.15326 2.25 3.75V20.25C2.25 20.8467 2.48705 21.419 2.90901 21.841C3.33097 22.2629 3.90326 22.5 4.5 22.5H19.5C20.0967 22.5 20.669 22.2629 21.091 21.841C21.5129 21.419 21.75 20.8467 21.75 20.25V3.75C21.75 3.15326 21.5129 2.58097 21.091 2.15901C20.669 1.73705 20.0967 1.5 19.5 1.5ZM17.25 19.5H6.75C6.55109 19.5 6.36032 19.421 6.21967 19.2803C6.07902 19.1397 6 18.9489 6 18.75C6 18.5511 6.07902 18.3603 6.21967 18.2197C6.36032 18.079 6.55109 18 6.75 18H17.25C17.4489 18 17.6397 18.079 17.7803 18.2197C17.921 18.3603 18 18.5511 18 18.75C18 18.9489 17.921 19.1397 17.7803 19.2803C17.6397 19.421 17.4489 19.5 17.25 19.5ZM17.25 16.5H6.75C6.55109 16.5 6.36032 16.421 6.21967 16.2803C6.07902 16.1397 6 15.9489 6 15.75C6 15.5511 6.07902 15.3603 6.21967 15.2197C6.36032 15.079 6.55109 15 6.75 15H17.25C17.4489 15 17.6397 15.079 17.7803 15.2197C17.921 15.3603 18 15.5511 18 15.75C18 15.9489 17.921 16.1397 17.7803 16.2803C17.6397 16.421 17.4489 16.5 17.25 16.5ZM18.75 11.25C18.75 11.6478 18.592 12.0294 18.3107 12.3107C18.0294 12.592 17.6478 12.75 17.25 12.75H6.75C6.35218 12.75 5.97064 12.592 5.68934 12.3107C5.40804 12.0294 5.25 11.6478 5.25 11.25V6C5.25 5.60218 5.40804 5.22064 5.68934 4.93934C5.97064 4.65804 6.35218 4.5 6.75 4.5H17.25C17.6478 4.5 18.0294 4.65804 18.3107 4.93934C18.592 5.22064 18.75 5.60218 18.75 6V11.25Z"
                  fill="currentColor"
                />
                <path d="M6.75 6H17.25V11.2508H6.75V6Z" fill="currentColor" />
              </svg>
            </div>
            {t("Resource.Blog")}
          </Link>
        </li>

        <li>
          <Link
            href={"/update-harga-ayam"}
            className={cn(
              pathname == "/update-harga-ayam" && "text-[#F5BE01] bg-[#FFFAEC]",
              "inline-flex gap-4 items-center group hover:text-[#F5BE01] hover:bg-[#FFFAEC] transition-colors ease-in duration-75 h-14 rounded-sm px-6 w-full"
            )}
          >
            <div>
              <svg
                className="text-[#667085] group-hover:text-[#F5BE01] transition-colors ease-in duration-75"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.1371 4.728L17.9671 6.558C20.6561 9.248 22.0001 10.592 22.0001 12.262C22.0001 13.933 20.6561 15.277 17.9671 17.966C15.2771 20.656 13.9331 22 12.2621 22C10.5921 22 9.24711 20.656 6.55811 17.967L4.72811 16.137C3.18311 14.591 2.41011 13.819 2.12311 12.816C1.83511 11.813 2.08111 10.748 2.57311 8.619L2.85611 7.391C3.26911 5.599 3.47611 4.703 4.08911 4.089C4.70311 3.476 5.59911 3.269 7.39111 2.856L8.61911 2.572C10.7491 2.081 11.8131 1.835 12.8161 2.122C13.8191 2.41 14.5921 3.183 16.1371 4.728ZM11.1461 14.328C10.4731 13.656 10.4781 12.69 10.8811 11.925C10.7813 11.7809 10.7352 11.6064 10.7507 11.4318C10.7662 11.2572 10.8423 11.0936 10.9659 10.9693C11.0895 10.845 11.2527 10.7679 11.4272 10.7514C11.6017 10.7349 11.7764 10.7801 11.9211 10.879C12.2611 10.699 12.6341 10.603 13.0061 10.607C13.205 10.6089 13.3951 10.6897 13.5344 10.8316C13.6737 10.9736 13.751 11.1651 13.7491 11.364C13.7473 11.5629 13.6665 11.7529 13.5245 11.8923C13.3825 12.0316 13.191 12.1089 12.9921 12.107C12.7606 12.1156 12.5417 12.2151 12.3831 12.384C11.9961 12.771 12.0971 13.159 12.2061 13.268C12.3161 13.377 12.7031 13.478 13.0901 13.091C13.8741 12.307 15.2281 12.047 16.0951 12.914C16.7681 13.587 16.7631 14.553 16.3601 15.318C16.4592 15.4621 16.5049 15.6364 16.4891 15.8106C16.4733 15.9849 16.3972 16.1481 16.2738 16.2721C16.1504 16.3961 15.9875 16.473 15.8133 16.4896C15.6392 16.5062 15.4647 16.4614 15.3201 16.363C14.8713 16.6091 14.3508 16.6912 13.8481 16.595C13.6532 16.555 13.4821 16.4391 13.3726 16.273C13.2631 16.1068 13.2241 15.9039 13.2641 15.709C13.3042 15.5141 13.42 15.343 13.5862 15.2335C13.7523 15.124 13.9552 15.085 14.1501 15.125C14.3271 15.162 14.6131 15.104 14.8581 14.859C15.2451 14.471 15.1441 14.084 15.0351 13.975C14.9251 13.866 14.5381 13.765 14.1511 14.152C13.3671 14.936 12.0131 15.196 11.1461 14.328ZM10.0201 10.293C10.2058 10.1072 10.3531 9.88674 10.4536 9.64406C10.554 9.40139 10.6057 9.1413 10.6057 8.87865C10.6056 8.616 10.5538 8.35593 10.4533 8.11329C10.3527 7.87065 10.2054 7.65019 10.0196 7.4645C9.83386 7.27881 9.61335 7.13153 9.37067 7.03106C9.128 6.93059 8.86791 6.8789 8.60526 6.87895C8.34261 6.879 8.08254 6.93078 7.8399 7.03133C7.59726 7.13189 7.3768 7.27925 7.19111 7.465C6.81609 7.84015 6.60546 8.34891 6.60556 8.87935C6.60565 9.4098 6.81646 9.91848 7.19161 10.2935C7.56676 10.6685 8.07552 10.8791 8.60596 10.8791C9.13641 10.879 9.64509 10.6681 10.0201 10.293Z"
                  fill="#475467"
                />
              </svg>
            </div>
            {t("Resource.UpdateHargaAyam")}
          </Link>
        </li>
      </ul>
    </div>
  );
}
